export const SET_SELECTED_BOOKING = "SET_SELECTED_BOOKING";
export const SET_BOOKINGS_LIST = "SET_BOOKINGS_LIST";
export const SET_LISTINGBOOKINGS_LIST = "SET_LISTINGBOOKINGS_LIST";
export const SET_BOOKINGS_REPLACEONE = "SET_BOOKINGS_REPLACEONE";
export const SET_LISTINGBOOKINGS_REPLACEONE = "SET_LISTINGBOOKINGS_REPLACEONE";
